import angular from 'angular';
import CollapsiblePaneComponent from './collapsible-pane.component';

const CollapsiblePaneModule = angular
    .module('control-room.commons.data.components.collapsible-pane', [])
    .component('crCollapsiblePane', CollapsiblePaneComponent);

export default CollapsiblePaneModule;
